import { apiClient } from '../api/apiClient'

export const assembleEntity = (form) => {
    let entity = {}
    //console.log("Received a form with the following elements:")
    for (let i = 0; i < form.elements.length; i++) {
        const element = form.elements[i]
        //console.log(element)
        if (element.name && element.name.length && element.name.length > 0 && element.type) {
            if (element.type == "radio") {
                if (element.checked == true) {
                    entity[element.name] = element.value
                }
            }
            else if (element.type == "checkbox") {
                entity[element.name] = element.checked == true
            }
            else {
                entity[element.name] = element.value
                //console.log("Assigned value ".concat(element.value).concat(" to entity field ").concat(element.name))
            }
        }
    }
    return entity
}

/**
 * This function currently does not support file uploads
 */
export const submitForm = async ({ form, validators = null, accessToken = null, headers = {
    'Shift4-Rest-Request-Envelope-Version': '1',
    'Shift4-Rest-Response-Envelope-Version': '1'
}, body = null }) => {
    if (accessToken && !("Authorization" in headers)) {
        headers["Authorization"] = `Token token="${accessToken}"`
    }
    if (!("Content-Type" in headers)) {
        headers["Content-Type"] = "application/json"
    }
    if (body == null) {
        switch (headers['Content-Type']) {
            case "application/json":
                body = {}
                break
            case "application/x-www-form-urlencoded":
                body = new FormData(form)
                break
            default:
                throw new Error("Unsupported Content-Type ".concat(headers['Content-Type']))
        }
    }
    if (form.elements && form.elements.length) {
        let valid = true
        for (let i = 0; i < form.elements.length; i++) {
            const input = form.elements[i]
            if (!validateInput(input, validators)) {
                valid = false
            }
            else if (input.name) {
                if (body instanceof FormData) {
                    body.append(input.name, input.value)
                }
                else {
                    body[input.name] = input.value
                }
                console.log("Added input ".concat(input.name).concat(" to formdata"))
            }
            else {
                console.log("Input lacks a name:")

            }
        }
        if (!valid) {
            return { message: "Input validation failed" }
        }
        //window.alert("Logged inputs")
    }
    else {
        //window.alert("No inputs to log")
    }

    const url = form.action

    body = body instanceof FormData ? body : JSON.stringify(body)

    let request = {
        method: form.method,
        cache: "no-cache",
        headers: headers
    }
    if (body) {
        request['body'] = body
    }
    console.log("Request:")
    console.log(request)
    return await apiClient(url, accessToken, request, null)
}

export const validateForm = (form, validators) => {
    let valid = true
    if (form.elements && form.elements.length) {
        for (let i = 0; i < form.elements.length; i++) {
            const input = form.elements[i]
            if (!validateInput(input, validators)) {
                valid = false
            }
        }
    }
    return valid
}

export const naturalValidateInput = (input, report = true) => {
    let errorMessages = []
    if (input.validationMessage && input.validationMessage.length) {
        errorMessages.push(input.validationMessage)
    }
    if (input.validityState) {
        if (input.validityState.badInput) {
            errorMessages.push("Bad input.")
        }
        if (input.validityState.patternMismatch) {
            errorMessages.push("Invalid input.")
        }
        if (input.validityState.rangeOverflow) {
            errorMessages.push("Input exceeds maximum value ".concat(input.getAttribute("max")))
        }
        if (input.validityState.rangeUnderflow) {
            errorMessages.push("Input contains less than minimum value ".concat(input.getAttribute("min")))
        }
        if (input.validityState.stepMismatch) {
            errorMessages.push("Input value must be aligned to the nearest multiple of ".concat(input.getAttribute("step")))
        }
        if (input.validityState.tooLong) {
            errorMessages.push("Length of input exceeds maximum of ".concat(input.getAttribute("maxlength")).concat(" characters."))
        }
        if (input.validityState.tooShort) {
            errorMessages.push("Value is too short (minimum ".concat(input.getAttribute("minlength")).concat(" characters)."))
        }
        if (input.validityState.typeMismatch) {
            errorMessages.push("Input type mismatch.")
        }
        if (input.validityState.valueMissing) {
            errorMessages.push("This field is required.")
        }
        input.setCustomValidity(errorMessages.join(" "))
    }
    else {
        return true
    }
    if (report) {
        return input.reportValidity()
    }
}

export const validateInput = async (input, validators, type = null, recursive = false) => {
    if (!recursive) {
        //clean up from previous validation
        input.removeAttribute("title")
        input.setCustomValidity('')
        if (type == null) {
            naturalValidateInput(input, false)
        }
    }

    let errorMessages = []
    const previousError = input.validationMessage
    if (previousError.length && previousError.length > 0) {
        errorMessages.push(previousError)
    }

    if (input.hasAttribute('data-validators')) {
        const validatorKeyValues = JSON.parse(input.getAttribute('data-validators'))
        console.log(validatorKeyValues)
        if (type == null) {
            console.log("Did not specify a validator type, will run all of them")
            for (let key in validatorKeyValues) {
                if (key == null) {
                    console.error("Error, null validator type")
                    continue
                }
                else if (!(key in validatorKeyValues)) {
                    console.log("There are no validators for events of type ".concat(key))
                    continue
                }
                console.log("Calling function recursively on validators of type ".concat(key))
                validateInput(input, validators, key, true)
            }
        }
        else {
            if (!(type in validatorKeyValues)) {
                console.log("There are no validators for events of type ".concat(type))
                return
            }
            console.log("About to run validators for event of type ".concat(type))
            const validatorNames = validatorKeyValues[type]
            if (validatorNames && validatorNames.length && validatorNames.length > 0) {
                let validity = true
                let alreadyValidated = {}
                for (let j = 0; j < validatorNames.length; j++) {
                    const validatorName = validatorNames[j]
                    if (validatorName in validators) {
                        if (validatorName in alreadyValidated) {
                            console.log("AlLready validated ".concat(validatorName))
                            continue
                        }
                        alreadyValidated[validatorName] = type
                        const validator = validators[validatorName]
                        if (!validator) {
                            console.error("Validator \"".concat(validatorName).concat("\" is null"))
                            validity = false
                            errorMessages.push("Invalid validator \"".concat(validatorName).concat("\""))
                        }
                        else if (typeof validator != 'function') {
                            console.error("Validator \"".concat(validatorName).concat("\" is not a function"))
                            return
                        }
                        console.log("About to execute validator ".concat(validatorName))
                        try {
                            if (!validator(input)) {
                                console.log("Validator \"".concat(validatorName).concat("\" failed"))
                                validity = false
                                errorMessages.push(input.getAttribute('data-msg'))
                            }
                        }
                        catch (error) {
                            console.log("Validator threw the following error: \"".concat(error.toString()).concat("\""))
                            validity = false
                            errorMessages.push(error.toString())
                        }
                    }
                    else {
                        const msg = "Instant validator \"".concat(validatorName).concat("\" is undefined")
                        console.error(msg)
                        validity = false
                        errorMessages.push(msg)
                    }
                }
                if (!validity) {
                    const title = errorMessages.join(" ")
                    input.setCustomValidity(title)
                    if (!recursive) {
                        input.setAttribute("title", title)
                    }
                }
            }
            else {
                console.log("There are no validators of type ".concat(type))
                console.log(validatorNames)
            }
        }
    }
    else {
        console.log("No validators for input ".concat(input.getAttribute("name")))
        console.log(input)
    }
    if (!recursive) {
        return input.reportValidity()
    }
    return !input.validationMessage || input.validationMessage.length == 0
}